import { Link } from "react-router-dom";

export default function Atelier() {
  return (
    <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="max-w-3xl">
        <div className="ie-overline text-brand-accent mb-4">
          The House
        </div>

        <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[1.05]">
          The Atelier
        </h1>

        <p className="text-text-secondary text-base md:text-lg leading-relaxed mt-6">
          INDUS EIRENE is a quiet luxury house rooted in the meeting of
          Indian heritage and Greek serenity. We create considered clothing
          for everyday life, with an emphasis on restraint, quality and
          enduring design.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-12 mt-20">
        <section>
          <div className="ie-overline text-brand-accent mb-4">
            Our Philosophy
          </div>
          <h2 className="font-serif text-3xl mb-5">
            Less, but considered.
          </h2>
          <p className="text-text-secondary text-sm leading-7">
            We believe clothing does not need to compete for attention.
            Thoughtful proportions, refined details and comfortable materials
            allow each piece to speak quietly.
          </p>
        </section>

        <section>
          <div className="ie-overline text-brand-accent mb-4">
            Made to Last
          </div>
          <h2 className="font-serif text-3xl mb-5">
            Beyond the season.
          </h2>
          <p className="text-text-secondary text-sm leading-7">
            Our collections are designed with longevity in mind — pieces that
            can remain part of a wardrobe long after a particular trend has
            passed.
          </p>
        </section>
      </div>

      <div className="border-t border-border mt-20 pt-10 flex flex-wrap gap-4">
        <Link to="/shop" className="ie-btn-primary">
          Explore the Atelier
        </Link>
        <Link to="/sustainability" className="ie-btn-ghost">
          Our Approach
        </Link>
      </div>
    </div>
  );
}